import styled from 'styled-components';

import DispatchingActionsTooltip from './component';

export default styled(DispatchingActionsTooltip)`
  .separator {
    margin: 0 16px;
    border-bottom: 1px solid var(--grey200);
  }

  .action_button {
    height: 36px;
    padding: 0 16px;
    width: 100%;
    text-align: left;
    color: var(--grey800);
    border: 0;
    background: transparent;
    &:hover {
      cursor: pointer;
      background-color: var(--primary100);
    }

    overflow: hidden;
    white-space: nowrap;
    outline: none;

    &:first-child {
      border-radius: 4px 4px 0 0;
    }

    &:last-child {
      border-radius: 0 0 4px 4px;
    }
  }
`;
